import { Component, OnDestroy, OnInit, Renderer2, ChangeDetectionStrategy, effect, inject, output, input } from '@angular/core';
import { environment } from '@environments/environment';
import * as routes from '@app/routes';
import { resolveEnvironmentLabel } from './environment-label';
import { RouterLink } from '@angular/router';

const ENV_BAR_ROOT_CLASS = 'has-env-bar';

@Component({
  selector: 'app-env-bar',
  templateUrl: './env-bar.component.html',
  styleUrls: ['./env-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink]
})
export class EnvBarComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);

  readonly showDetailsLink = input(false);
  readonly impersonatedName = input<string | null>(null);

  readonly revertImpersonation = output<void>();

  detailsRoute = routes.environmentInfo();
  label: string | null = null;

  constructor() {
    // The page makes room for the bar while it shows: from the first check on (the label is
    // known by then), and again when an impersonation starts or ends.
    effect(() => this.syncRootClass());
  }

  get visible(): boolean {
    return !!this.label || !!this.impersonatedName();
  }

  ngOnInit(): void {
    this.label = resolveEnvironmentLabel(window.location.hostname, environment.name);
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.documentElement, ENV_BAR_ROOT_CLASS);
  }

  onRevert(): void {
    this.revertImpersonation.emit();
  }

  private syncRootClass(): void {
    if (this.visible) {
      this.renderer.addClass(document.documentElement, ENV_BAR_ROOT_CLASS);
    } else {
      this.renderer.removeClass(document.documentElement, ENV_BAR_ROOT_CLASS);
    }
  }
}
